import { BlastEvent, SimulationConfig } from '../../../types';
import { getRadiusAtAngle } from '../../../break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const AuroraBorealisAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  ctx.save(); ctx.beginPath();
  for(let a=0; a<Math.PI*2; a+=0.1){
      const rBase = e.maxRadius + Math.sin(a * 5 + progress * 10) * 40 * (1-progress);
      const r = getRadiusAtAngle(a, e, rBase);
      if (a === 0) ctx.moveTo(e.pos.x + Math.cos(a)*r, e.pos.y + Math.sin(a)*r);
      else ctx.lineTo(e.pos.x + Math.cos(a)*r, e.pos.y + Math.sin(a)*r);
  }
  ctx.closePath(); ctx.lineWidth = 30 * (1-progress); ctx.globalAlpha = (1-progress) * 0.4; ctx.stroke(); ctx.restore();
};

registerBlastAnimation('AURORA_BOREALIS', AuroraBorealisAnimation);
